import React from "react";
import {Col, Row} from "antd";
import {RowProps}  from "antd";
import {useStore} from "@/store/useStore";

interface PageContainerPropsType extends RowProps{
    children: any,
    height?: string,
    mainBackgroundColor?: string,
    leftBackgroundColor?: string,
    centerBackgroundColor?: string,
    rightBackgroundColor?: string,
}
export const PageContainer: React.FC<PageContainerPropsType> = (props) => {
    const {children, align = "middle", justify, height="auto",  mainBackgroundColor, leftBackgroundColor, rightBackgroundColor, centerBackgroundColor} = props;
    const { isMobile, isTablet } = useStore();
    const isCompactScreen = isMobile || isTablet;

    return (
        <Row wrap={false} align={align} justify={justify} style={{minHeight: height, background: mainBackgroundColor}}>
            <Col flex={isCompactScreen ? "0 0 0" : "auto"} style={{background: leftBackgroundColor, overflow: "hidden"}}>
                <span style={{display:"inline-block", minHeight: height}}>&nbsp;</span>
            </Col>
            <Col flex={isCompactScreen ? "1 1 100%" : "1320px"} style={{background: centerBackgroundColor, padding: isCompactScreen ? "0 16px" : "0 24px", minWidth: 0}}>
                {children}
            </Col>
            <Col flex={isCompactScreen ? "0 0 0" : "auto"} style={{background: rightBackgroundColor, overflow: "hidden"}}>
                <span style={{display:"inline-block", minHeight: height}}>&nbsp;</span>
            </Col>
        </Row>
    );
}